import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DataSyncService extends BaseService{
  constructor(http: HttpClient) { super(http); }
  private url = 'api/basicDataSyn';
  getUrl(): string {
    return this.url;
  }

  /** 数据同步 */
  synchronization(object:any):Observable<any> {
    let url = this.getUrl() + "/synchronization";
    return this.http.put<any>(url, object, httpOptions).pipe(
      tap(_ => this.log(`updated object =${object}`)),
      catchError(
        this.handleError<any>('updateany')
      )
    );
  }

  /**
   * Sap 数据查询
   * **/
  searchFromSap(object:any):Observable<any> {

    let url = this.getUrl() + "/searchFromSap";
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap(_ => this.log(`updated object =${object}`)),
      catchError(
        this.handleError<any>('updateany')
      )
    );

  }

}
